<template>
  <div class="breadcrumbs_wrap">
    <router-link v-for="(item, index) in items" :key="item.pathName + index" :to="{ name: item.pathName, params: {id: item.item_id || null} }">{{ item.name }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumbs',
  computed: {
    items () {
      return this.$route.meta.breadcrumbs() || []
    }
  }
}
</script>

<style scoped>

</style>
